import { select, take, takeLatest } from "redux-saga/effects";

import GaReporter from "../../../utilities/gaReporter";
import { CONFIGURATION_CHANGED, CONFIGURATION_LOADED } from "../../actions/configurationActions";
import { SET_SESSION_DATA } from "../../actions/sessionActions";
import { getAccount, getAppVersion, getFrontendSettings, getModelId } from "../selectors";

export function* initGoogleAnalyticsSaga(): any {
    yield take(SET_SESSION_DATA);

    const frontendSettings = yield select(getFrontendSettings);
    if (!frontendSettings.ga_tracking_enabled) {
        return;
    }

    // Allow reporting both to a GA property common for all DS apps, and a GA property
    // for a specific customer which we can share to them.
    const trackingIds = [frontendSettings.ga_common_measurement_id, frontendSettings.ga_measurement_id].filter(
        id => !!id
    );
    if (trackingIds.length === 0) {
        return;
    }

    // Set the application base URL as cookie path, removing "configurator/" and "/summary".
    const siteUrl = new URL(window.location.href);
    const cookiePath = siteUrl.pathname.replace(/\/[^/]+\/?(summary)?$/i, "") || "/";
    const useCookies = (siteUrl.searchParams.get("allow_statistical_cookies") || "false").toLowerCase() === "true";
    const applicationType = siteUrl.searchParams.get("ga_application_type") || "Web";

    const appVersion = yield select(getAppVersion);
    GaReporter.initTracking(trackingIds, useCookies, cookiePath, applicationType, appVersion);
    if (frontendSettings.ga_tracking_project) {
        GaReporter.setProject(frontendSettings.ga_tracking_project);
    }

    const account = yield select(getAccount);
    if (account) {
        GaReporter.setAccountId(account.id);
    }
}

export function* updateGoogleAnalyticsModelIdSaga(): any {
    yield takeLatest([CONFIGURATION_CHANGED, CONFIGURATION_LOADED], function* (): any {
        const modelId = yield select(getModelId);
        GaReporter.setModelId(modelId);
    });
}
